import template from '../../templates/settings/PaymentLayout.ejs';
import formTemplate from '../../templates/settings/Payment.ejs';
import daysCalculationTypeTemplate
    from '../../templates/settings/PaymentDaysCalculationType.ejs';
import FormView from 'commons/views/Form';
import loader from 'helpers/loader';
import modal from 'helpers/modal';
import HolidaysModalView from 'commons/views/HolidaysModal.js';
import Holidays from 'newCollections/holidays.js';
import WorkingDaysModalView from 'commons/views/WorkingDaysModal.js';
import moment from 'moment';
import tooltip from '../../../helpers/tooltip';

const SettingsView = FormView.extend({
    events() {
        return Object.assign(FormView.prototype.events(), {
            'click .js-edit-holidays': 'showHolidaysModal',
            'click .js-edit-working-days': 'showWorkingDaysModal',
            'focusout [name="unpaidLeaveFixedDays"]':
                'toggleErrorUnpaidLeaveFixedDays'
        });
    },

    initialize(options) {
        this.options = Object.assign({}, {
            template: formTemplate,
            unsubmittedPayroll: null,
            holidaysModal: null,
            workingDaysModal: null,
            defaults: true
        }, options || {});

        this.options.templateExtra = {defaults: this.options.defaults};

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    render() {
        FormView.prototype.render.apply(this, arguments);
        this.$('[name="holidayStates"]').chosen({width: '100%'});

        // <-- days calculation type -->
        this.$('#days-calculation-type-container').append(
            daysCalculationTypeTemplate({
                model: {
                    name: 'prorate',
                    text: 'Prorate Salary',
                    title: 'Please note that the basis for salary proration applicable to all employees under the ' +
                        'Employment Act since 1 Jan 2023 is All Days in Current Calendar Month.',
                    calculationType: this.model.get('prorateCalculationType'),
                    fixedDays: this.model.get('prorateFixedDays'),
                    isEnabled: true
                }
            })
        );
        this.$('#days-calculation-type-container').append(
            daysCalculationTypeTemplate({
                model: {
                    name: 'overtime',
                    text: 'Overtime',
                    title: 'Please refer to the Ordinary Rate of Pay paragraph to determine your basis for overtime calculation',
                    calculationType: this.model.get('overtimeCalculationType'),
                    fixedDays: this.model.get('overtimeFixedDays'),
                    isEnabled: true
                }
            })
        );
        this.$('#days-calculation-type-container').append(
            daysCalculationTypeTemplate({
                model: {
                    name: 'unpaidLeave',
                    text: 'Unpaid Leave',
                    title: 'Please note that the basis for unpaid leave calculation applicable to all employees under the ' +
                        'Employment Act since 1 Jan 2023 is All Days in Current Calendar Month.',
                    calculationType: this.model.get('unpaidLeaveCalculationType'),
                    fixedDays: this.model.get('unpaidLeaveFixedDays'),
                    isEnabled: this.model.get('recordUnpaidLeaveInPayroll') === true
                }
            })
        );
        // </- days calculation type -->
        tooltip.init(this);
        return false;
    },

    bindHandlers() {
        const r = FormView.prototype.bindHandlers.apply(this, arguments);

        if (this.options.defaults) {
            this.model.on(
                'change:recordUnpaidLeaveInPayroll',
                this.toggleUnpaidLeaveFields,
                this
            );

            // <-- days calculation type -->
            this.model.on(
                'change:prorateCalculationType',
                () => this.toggleFixedDays('prorate', true),
                this
            );
            this.model.on(
                'change:overtimeCalculationType',
                () => this.toggleFixedDays('overtime', true),
                this
            );
            this.model.on(
                'change:unpaidLeaveCalculationType',
                this.toggleUnpaidLeaveFixedDays,
                this
            );
            // </- days calculation type -->
        } else {
            this.model.on(
                'change:useDefaultPaymentSettings',
                this.toggleLocationSettings,
                this
            );
        }

        return r;
    },

    unbindHandlers() {
        FormView.prototype.unbindHandlers.apply(this, arguments);
        this.options.holidaysModal.off('save', null, this);
        return this;
    },

    showHolidaysModal(ev) {
        ev.preventDefault();
        this.options.holidaysModal.show();
    },

    showWorkingDaysModal(ev) {
        ev.preventDefault();
        this.options.workingDaysModal.show();
    },

    toggleLocationSettings() {
        this.$('[name=holidayStates],.js-edit-holidays')
            .each((i, el) => {
                $(el)
                    .prop(
                        'disabled',
                        this.model.get('useDefaultPaymentSettings')
                    )
                    .attr(
                        'disabled',
                        this.model.get('useDefaultPaymentSettings')
                    );
            });
        this.$('[name=holidayStates]').trigger('chosen:updated');
        this.$('.js-edit-working-days').attr(
            'disabled',
            this.model.get('useDefaultPaymentSettings')
        );
    },

    toggleUnpaidLeaveFields() {
        this.$('[name=unpaidLeaveCalculationType]').prop(
            'disabled',
            this.model.get('recordUnpaidLeaveInPayroll') !== true
        );

        this.toggleError('unpaidLeaveCalculationType');

        this.toggleUnpaidLeaveFixedDays();
    },

    toggleUnpaidLeaveFixedDays() {
        return this.toggleFixedDays(
            'unpaidLeave',
            this.model.get('recordUnpaidLeaveInPayroll') === true
        );
    },
    toggleFixedDays(name, isEnabled) {
        $(`[name=${name}FixedDays]`).prop('disabled', !isEnabled);

        if (this.model.get(`${name}CalculationType`) === 1) {
            this.$(`#${name}CalculationTypeContainer`)
                .removeClass('col-sm-9')
                .addClass('col-sm-4')
            ;
            this.$(`#${name}FixedDaysContainer`).show();
        } else {
            this.$(`#${name}CalculationTypeContainer`)
                .removeClass('col-sm-4')
                .addClass('col-sm-9')
            ;
            this.$(`#${name}FixedDaysContainer`).hide();
        }

        // because we reset ${name}FixedDays when switch to another type
        // we can use this value again when we switch back
        if (this.model.get(`${name}CalculationType`) === 1) {
            const days = parseInt(this.$(`[name=${name}FixedDays]`).val(), 10);
            this.model.set({[`${name}FixedDays`]: days});
        }
    },

    toggleErrorUnpaidLeaveFixedDays() {
        if (!this.model.wasValid()) {
            this.invalid(this.model, {errors: this.model.validationError});
        } else {
            this.valid();
        }
    },

    resetPayrollConfirm() {
        return new Promise((resolve, reject) => {
            if (!this.options.unsubmittedPayroll) {
                return resolve(true);
            }

            modal.confirm({
                title: 'Your saved payroll will be modified!',
                text:  'You have an unsubmitted payroll saved. ' +
                    'If you continue, the payroll details of all employees ' +
                    'will be updated based on the modifications you are ' +
                    'about to save. Also, any unsaved payroll details ' +
                    'will be lost.',
                customClass: 'sweet-alert-error',
                confirmButtonText: 'Yes, Save Settings',
                callback: confirm => {
                    if (confirm) {
                        resolve(true);
                    } else {
                        reject();
                    }
                }
            });
        });
    },

    save(ev) {
        const $button = this.$(ev.currentTarget);
        let stopLoader;

        // if we don't return early on an invalid model, setting
        // holidayStates and payslipSize clears old validation errors and
        // the model is saved anyway.
        if (!this.model.wasValid()) {
            const errors = this.model.validationError;
            this.invalid(this.model, {errors});
            // Poping up a form validation message,
            // advising that Fixed Days (enabled or disabled) as not filled
            _.forEach(errors, ([error]) => this.model.trigger('alert', error));
            return;
        }

        this.model.set({
            holidayStates: this.$('[name="holidayStates"]').val() || [],
            payslipSize: this.$('[name="payslipSize"]').val() || 'A4',
            hrdfContribution: this.$('[name="hrdfContribution"]').val() ||
              'auto',
        });

        // make sure the user is OK with resetting any unsubmitted payroll
        return this.resetPayrollConfirm()
            // save the settings
            .then(() => {
                stopLoader = loader.startFullScreen($button);
                return this.model.save()
                    .catch(err => {
                        if (this.model.wasValid()) {
                            // the error is not a validation error
                            throw err;
                        }
                        throw new Error('validationError');
                    });
            })
            // reset the payroll
            .then(() => {
                if (this.options.unsubmittedPayroll) {
                    return this.options.unsubmittedPayroll.reset();
                }

                return Promise.resolve(true);
            })
            // refresh the collection of holidays
            .then(() => app.holidays.fetch())
            // finish
            .then(() => {
                modal.showAlertSuccess('Payment settings have been saved');
                return Promise.resolve(true);
            })
            .catch(err => {
                if (
                    typeof err === 'object' &&
                    err.message !== 'validationError'
                ) {
                    modal.error({text: err});
                }
            })
            .finally(() => {
                if (typeof stopLoader === 'function') {
                    stopLoader();
                }
            });
    }
});

module.exports = Backbone.View.extend({
    events() {
        return {
            'change .js-ext-location': 'changeLocation'
        };
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            unsubmittedPayroll: null,
            locations: null,
            holidays: null
        });

        this.locations = this.options.locations;

        return this.render();
    },

    render() {
        this.hqLocation = this.options.locations
            .find(location => location.get('primary'));

        this.$el.html(
            this.options.template({
                locations: this.options.locations,
                locationId: this.hqLocation.id
            })
        );

        this.$('.js-ext-location').chosen({width: '100%'});
        this.renderSettings(this.hqLocation);
        return this;
    },

    changeLocation(ev) {
        const $input = this.$(ev.currentTarget);
        const val = $input.val();

        const location = this.options.locations.find(l => l.id === val);
        this.renderSettings(location);
    },

    renderSettings(location) {
        if (this.settingsView) {
            this.settingsView.remove();
        }

        if (!this.holidaysModal) {
            this.holidaysModal = new HolidaysModalView({
                collection: new Holidays(null, {
                    all: true,
                    company: app.company,
                    location: location.id,
                    dateStart: moment().startOf('year').toDate(),
                    forceFetch: true
                }),
                location: location
            });
        } else {
            this.holidaysModal.setLocation(location);
            this.holidaysModal.collection.setOptions({
                all: true,
                company: app.company,
                location: location.id,
                dateStart: moment().startOf('year').toDate(),
                forceFetch: true
            });
        }

        this.workingDaysModal = new WorkingDaysModalView({
            company: this.model,
            location: location
        });

        this.settingsView = new SettingsView({
            model: location.get('primary') ? app.company : location,
            unsubmittedPayroll: this.options.unsubmittedPayroll,
            holidaysModal: this.holidaysModal,
            workingDaysModal: this.workingDaysModal,
            defaults: location.get('primary')
        });

        this.$('.js-ext-settings-container').append(
            this.settingsView.el
        );

        this.holidaysModal.collection.fetch({reset: true, force: true});
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PaymentLayout.js